<template>
    <div>
        <div class="flex-grow-1 text-sm a-infoBar a-infoBar--warning mb-4">
            Liczba aktywnych promocji własnych jest ograniczona. Jeśli limit
            zostanie wykorzystany, można usunąć trwającą promocję, aby założyć
            nową.
        </div>
        <div class="t-shops-settings d-flex gap-1 flex-wrap">
            <div class="custom-checkbox" style="white-space: nowrap">
                <the-btn
                    text="Zaznacz wszystkie"
                    class="btn-outline-custom d-none d-sm-inline-flex"
                    :class="{ 'd-inline-flex': !allowSelectAll }"
                    icon="CheckCorrect"
                    @click.native="selectMerchants(true)"
                />
                <the-btn
                    text="Odznacz wszystkie"
                    class="
                            btn-danger
                            ml-sm-2
                            d-none d-sm-inline-flex
                        "
                    :class="{ 'd-inline-flex': allowSelectAll }"
                    icon="CheckIncorrect"
                    @click.native="selectMerchants(false)"
                />
            </div>
            <slot></slot>
        </div>
        <div class="t-shops scrollbar">
            <div class="scrollbar-shadow is-top"></div>
            <single-merchant
                v-for="merchant in merchants"
                :key="merchant.id"
                :merchantId="merchant.id"
                :selectMerchant="selectMerchant"
                :selectedMerchants="selectedMerchants"
                :displayLimits="displayLimits"
            />
            <div class="scrollbar-shadow is-bottom"></div>
        </div>
    </div>
</template>

<script>
import SingleMerchant from '@/components/merchants/SingleMerchant'

export default {
    props: {
        merchants: {
            type: Array,
            required: true
        },
        selectMerchants: {
            type: Function,
            default: () => {}
        },
        selectMerchant: {
            type: Function,
            default: () => {}
        },
        selectedMerchants: {
            type: Array,
            default: () => []
        },
        displayLimits: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        allowSelectAll() {
            return this.merchants.length === this.selectedMerchants.length
        }
    },
    components: {
        SingleMerchant
    }
}
</script>
